<template>
	<div>
		<modal
			v-if="!showVideoModal"
			class="wholesale-product-modal"
			size="full"
			@close="$emit('close')"
		>
			<div slot="body">
				<div class="modal-header mb-3">
					<span>{{ category }}</span>
					<button type="button" class="close" aria-label="Close" @click="$emit('close')">
						<i class="bi bi-x-lg"></i>
					</button>
				</div>

				<hr />

				<div class="container-fliud">
					<div class="text-center">
						<div class="spinner-border" v-if="isLoading" role="status">
							<span class="sr-only">Loading...</span>
						</div>
					</div>

					<div class="wrapper row" v-if="!isLoading">
						<div class="col-md-5 p-0">
							<div class="px-4">
								<VueSlickCarousel
									ref="carouselmain"
									v-bind="carouselMain"
									@beforeChange="onBeforeChangeMain"
								>
									<div v-for="(picture, index) in product.pictures" :key="index">
										<img :src="picture" class="img-main" />
									</div>

									<div
										v-if="youtubeThumb(videos[0]) != ''"
										:key="getIndexOfVideo"
									>
										<img :src="youtubeThumb(videos[0])" class="img-main" />
									</div>
								</VueSlickCarousel>
							</div>

							<div class="px-4">
								<VueSlickCarousel
									ref="carouselthumb"
									v-bind="carouselControl"
									@beforeChange="onBeforeChangeThumb"
								>
									<div
										class="img-thumb-box"
										v-for="(picture, index) in product.pictures"
										:key="index"
									>
										<img :src="picture" class="img-thumb" />
									</div>
									<div
										class="img-thumb-box"
										v-if="youtubeThumb(videos[0]) != ''"
										:key="getIndexOfVideo"
									>
										<img
											:src="youtubeThumb(videos[0])"
											class="img-thumb"
											@click="showVideo(true)"
										/>
									</div>
								</VueSlickCarousel>
							</div>
						</div>

						<div class="details col-md-7">
							<private-order-detail-content
								:product="product"
								:is-product-loading="isLoading"
								:is-has-description="isHasDescription"
								:is-has-content="isHasContent"
								:is-has-breadcrumb="false"
								:show-tab-menu="false"
								full-width
							/>
						</div>
					</div>
				</div>
			</div>

			<div slot="footer">
				<button type="button" class="btn btn-light" @click="$emit('close')">
					{{ $t('_.close') }}
				</button>
			</div>
		</modal>

		<modal
			v-if="showVideoModal"
			class="wholesale-product-modal"
			size="large"
			@close="$emit('close')"
		>
			<div slot="body">
				<div class="container-fliud">
					<div class="wrapper row mt-4">
						<div class="col-md-12">
							<h4 class="product-title">{{ product.name }}</h4>
						</div>

						<div class="col-md-12">
							<div class="embed-responsive embed-responsive-16by9">
								<iframe
									class="embed-responsive-item"
									:src="videoEmbedUrl(videos[0])"
									allowfullscreen
								></iframe>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div slot="footer">
				<button type="button" class="btn btn-light" @click="showVideo(false)">
					{{ $t('_.close') }}
				</button>
			</div>
		</modal>
	</div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import Modal from '@/components/Modal.vue';
import PrivateOrderDetailContent from '@/components/private-orders/detail/ProductContent.vue';
import { getYoutubeId, getYoutubeThumb } from '@/lib/helper';

export default {
	components: {
		Modal,
		VueSlickCarousel,
		PrivateOrderDetailContent,
	},
	props: {
		product: {
			type: Object,
			default: () => ({}),
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			carouselMain: {
				arrows: false,
				asNavFor: this.$refs.carouselthumb,
				focusOnSelect: true,
			},
			videos: this.product.videos || [''],
			carouselControl: {
				arrows: true,
				asNavFor: this.$refs.carouselmain,
				slidesToShow: 5,
				focusOnSelect: true,
			},
			showVideoModal: false,
		};
	},
	computed: {
		category() {
			return this.product?.category?.category ?? '-';
		},
		getIndexOfVideo() {
			return this.product.pictures.length + 1;
		},
		isHasContent() {
			if (this.isLoading) return false;

			const marketingKit = this.product?.marketing_kit;
			const pages = this.product?.pages;

			let hasMarketingKit = marketingKit && marketingKit.visible;
			let hasPages = pages && pages.length > 0;

			if (hasMarketingKit === undefined) hasMarketingKit = false;
			if (hasPages === undefined) hasPages = false;

			return hasMarketingKit || hasPages;
		},
		isHasDescription() {
			if (this.isLoading) return false;
			return !(this.product?.description === '' || this.product?.description === null);
		},
	},
	methods: {
		onBeforeChangeMain(_currentPosition, nextPosition) {
			this.$refs.carouselthumb.goTo(nextPosition);
		},
		youtubeThumb(url) {
			const vidUrl = url || '';
			return getYoutubeThumb(vidUrl);
		},
		onBeforeChangeThumb(_currentPosition, nextPosition) {
			this.$refs.carouselmain.goTo(nextPosition);
		},
		showVideo(state) {
			this.showVideoModal = state;
		},
		videoEmbedUrl(videoUrl) {
			const videoId = getYoutubeId(videoUrl);
			return `https://www.youtube.com/embed/${videoId}`;
		},
	},
};
</script>

<style scoped lang="scss">
@import '../../../assets/scss/modules/_variables.scss';

::v-deep .slick-arrow:before {
	color: #2f3241;
	opacity: 1;
}

.slick-current .img-thumb {
	border: 2px solid $color__primary;
}

.dropship-product-preview {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	margin-top: 1px;
	font-size: 1rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

img.img-thumb {
	width: 100%;
	padding: 0px;
	border-radius: 8px;
	// max-height: 100px;
	aspect-ratio: 1 / 1;
	object-fit: contain;
	background-color: #f3f3f3;
	border: 1px solid #dfdfdf;
}

img.img-main {
	width: 100%;
	border-radius: 8px;
	// max-height: 500px;
	background-color: #f3f3f3;
	aspect-ratio: 1 / 1;
	object-fit: contain;
	border: 1px solid #f0f0f0;
}

.details {
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-ms-flex-direction: column;
	flex-direction: column;
}

.product-title,
.price,
.sizes,
.colors {
	/* text-transform: UPPERCASE; */
	font-weight: bold;
}

.price span {
	color: #ff9f1a;
}

.price {
	font-size: 24px;
	font-weight: 600;
	line-height: 32px;
	text-align: left;
}

.product-title,
.product-description {
	margin-bottom: 15px;
}

.capital-price {
	font-size: 14px;
	line-height: 22px;
	text-align: left;
}

.detail-title {
	font-size: 14px;
	line-height: 30px;
	text-align: left;
}

.stock {
	margin-bottom: 2px;
	margin-bottom: 4px;
	color: red;
	font-size: 0.9rem;
}

.subtitle span {
	font-weight: bolder;
}

.product-title {
	margin-top: 0;
}

.tooltip-inner {
	padding: 1.3em;
}

ul {
	list-style-type: none;
	padding-inline-start: 0px;
}

li ul {
	padding-inline-start: 20px;
}

.read {
	overflow: hidden;
	transition: all 0.3s;
}

.read-less {
	height: 210px !important;
	overflow: hidden;
}

.table th,
.table td {
	border-bottom: 0px solid #dee2e6;
}
.row {
	margin: 0;
}

.wholesale-product-modal .modal-container {
	border-radius: 16px;
}

.wholesale-product-modal .modal-footer {
	background-color: transparent;
}

.wholesale-product-modal .modal-header {
	background-color: transparent;
	border-bottom: none;
	padding: 2px 5px;
}

img.img-main {
	width: 100%;
	border-radius: 8px;
	// max-height: 500px;
	background-color: #f3f3f3;
	aspect-ratio: 1 / 1;
	object-fit: contain;
	border: 1px solid #f0f0f0;
}

.img-thumb-box {
	padding: 3px;
	cursor: pointer;
}

.details {
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-ms-flex-direction: column;
	flex-direction: column;
}
</style>
